// Anchor.js

import React, { useState } from "react";

const Anchor = ({text,onPress,href,force=false,nativeID,testID,style,textStyle,hoverStyle,...props})=>{
  if (!!force || (href?.substring(0,4)==="http" && typeof(onPress)!=="function")) {
    props.target = "_blank";
  }
  if (!text && !props.children && !!href) {
    text = href;
  }
  if (!!nativeID) {
    props.id = nativeID;
  }
  const _onPress = (e)=>{
    if (e.metaKey||e.ctrlKey) {
      // window.open(href, '_blank');  // CTRL-CLICK to open in new tab is happening natively. Something was fixed in here and now this 'window.open' was causing a second tab to open!
      // Cancel any other actions in this window.
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    if (!force) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (typeof(onPress)==="function") {
      onPress();
    } else if (!!href) {
      if (href.substring(0,4)==="http") {
        window.open(href, '_blank');
      } else {
        window.main.lib.setCurrentView(href);
      }
    }
  }
  const [hoverState,hoverSetState] = useState(false);
  const _onMouseEnter = ()=>{ hoverSetState(true); };
  const _onMouseLeave = ()=>{ hoverSetState(false); };
  if (typeof(onPress)==="function") {
    return (
      <a onClick={_onPress} data-testid={testID} style={{color:window.main.theme.colors[(!!hoverState?"auxiliaryHover":"auxiliary")],textDecoration:"none",...style,...textStyle,...(!!hoverState?hoverStyle:{})}} onMouseOver={()=>{this.style.color=window.main.theme.colors.auxiliaryHover}} onMouseOut={()=>{this.style.color=window.main.theme.colors.auxiliary}} {...props}>
        {props.children || text}
      </a>
    );
  } else {
    return (
      <a href={href||"#notimplemented"} onClick={_onPress} data-testid={testID} style={{color:window.main.theme.colors[(!!hoverState?"auxiliaryHover":"auxiliary")],textDecoration:"none",...style,...textStyle,...(!!hoverState?hoverStyle:{})}} onMouseEnter={_onMouseEnter} onMouseLeave={_onMouseLeave} {...props}>
        {props.children || text}
      </a>
    );
  }
}

export default Anchor;
